export enum RecordType {
    SickLeave = 1,
    Holiday = 2
}
